import TextFieldExtension from "../../@libs/TextFieldExtension";

import zipcodeValidation from "../../validations/zipcode";
import required from "@libs/required";

class ZipcodeTextField extends TextFieldExtension {
	constructor(...args) {
		super(...args);
	}

	get val() {
		return super.val;
	}

	get id() {
		return super.id;
	}

	get name() {
		return super.name;
	}

	get isValid() {
		return super.isValid;
	}

	validate(val = required`val`, customValidation) {
		return super.validate(
			val,
			customValidation || super.validation || zipcodeValidation
		);
	}

	displayError(val = required`val`) {
		super.displayError(val);
	}
}

export default ZipcodeTextField;
